import { render, staticRenderFns } from "./PPLabelDuration.vue?vue&type=template&id=6ea6c082&"
import script from "./PPLabelDuration.vue?vue&type=script&lang=js&"
export * from "./PPLabelDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../playmaker_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports